import { render } from "./PasswordPrompt.vue?vue&type=template&id=64a67d13&scoped=true"
import script from "./PasswordPrompt.vue?vue&type=script&lang=js"
export * from "./PasswordPrompt.vue?vue&type=script&lang=js"

import "./PasswordPrompt.vue?vue&type=style&index=0&id=64a67d13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a67d13"]])

export default __exports__